<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="asgnLIToFC_tooltip_NAME"  :name="asgnLIToFC_tooltip_NAME" :description="asgnLIToFC_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row">
      <div class="col-sm-12">
        <el-table
          :data="lineItems"
          :summary-method="summary"
          show-summary
          :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
        >
          <el-table-column :min-width="100" prop="itemNumber" label="Item No">
          </el-table-column>
          <el-table-column
            min-width="195"
            prop="fundCitationName"
            label="Fund Citation"
          >
            <editable-cell
              :disabled="isReadOnly || isPartnerAccount"
              :show-input="editMode"
              slot-scope="{ row }"
              editable-component="el-select"
              close-event="change"
              v-model="row.fundCitationName"
              v-on:input="markChanged(row.lineItemId)"
            >
              <span slot="content">
                {{ row.fundCitationName }}
              </span>
              <template slot="edit-component-slot">
                <el-option
                  v-for="fundCitation in fundCitations"
                  class="select-primary"
                  :label="fundCitation.abbreviation"
                  :value="fundCitation.fundCitationId"
                  :key="fundCitation.fundCitationId"
                >
                </el-option>
              </template>
            </editable-cell>
          </el-table-column>

          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :min-width="column.minWidth"
            :formatter="column.formatter"
            :prop="column.prop"
            :label="column.label"
          >
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; float: right" v-if="!isReadOnly && !isPartnerAccount">
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            v-show="editMode"
            type="danger"
            class="alert_footer_button mr-4 btn_extra_small btn_info"
            @click.native="cancelEditMode"
          >
            Cancel
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="handleEdit()"
          >
            {{ editMode ? "Save" : "Edit" }}
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option, Input } from "element-ui";
import { BaseSwitch, BaseButton, Modal } from "@/components";
import EditableCell from "@/components/App/order/invoice/assignlineitemfundcitation/LineItemEditable.vue";
import Util from "../../../../../util/util";
import toolTip  from "../../../Tooltip";

export default {
  name: "assign-line-item-fund-citation",
  props: ["isReadOnly"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    BaseSwitch,
    BaseButton,
    Modal,
    EditableCell,
    toolTip
  },
  data() {
    return {
      editMode: false,
      isNew: false,
      editing: null,
      changedItems: [],
      tableColumns: [
        {
          prop: "stockClassName",
          label: "Class of Supply",
          minWidth: 150,
        },
        {
          prop: "stockSubClassName",
          label: "Sub Class",
          minWidth: 150,
        },
        {
          prop: "stockDescription",
          label: "stock No & Description",
          minWidth: 200,
        },
        {
          prop: "unitMeasure",
          label: "Unit Of Measure",
          minWidth: 150,
        },
        {
          prop: "requestedQuantity",
          label: "Request Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.requestedQuantity);
          },
        },
        {
          prop: "receivedQuantity",
          label: "Received Qty",
          minWidth: 150,
          formatter: (value) => {
            return Util.numberWithCommas(value.receivedQuantity);
          },
        },
        {
          prop: "unitPrice",
          label: "Unit Price",
          minWidth: 125,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.unitPrice);
          },
        },
        {
          prop: "partnerItemTotal",
          label: "Partner Total",
          minWidth: 170,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.partnerItemTotal);
          },
        },
        {
          prop: "usItemTotal",
          label: "US Total($)",
          minWidth: 125,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.usItemTotal);
          },
        },
      ],
      asgnLIToFC_tooltip_NAME : '',
      asgnLIToFC_tooltip_DESCRIPTION : '',
    };
  },
  async mounted(){
    await this.getAllTooltips()
    this.loadToolTips()
  },
  computed: {
    ...mapGetters({
      lineItems: "lineItemInvoice/lineItems",
      lineItemsErrors: "lineItemInvoice/lineItemErrors",
      lineItemInvoiceStatus: "lineItemInvoice/lineItemInvoiceStatus",
      fundCitations: "fundCitation/fundCitations",
      financeSystems: "financeSystems/financeSystems",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
  },
  methods: {
    ...mapActions({
      getFundCitations: "fundCitation/getFundCitations",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      getLineItems: "lineItemInvoice/getLineItems",
      saveLineItems: "lineItemInvoice/saveLineItems",
      getLineItemInvoiceStatus: "lineItemInvoice/getLineItemInvoiceStatus",
      getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
      updateAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/updateAllDisbursingInfoByOrderId",
      clearLineItem: "lineItem/clearLineItem",
      getAllTooltips: "tooltip/getToolTips"

    }),
    loadToolTips(){
    const asgnLIToFCVal = this.toolTips.find(e => e.name === "AssignLineItemsModule")
    if(asgnLIToFCVal && asgnLIToFCVal.status){
      this.asgnLIToFC_tooltip_DESCRIPTION = asgnLIToFCVal.description ? asgnLIToFCVal.description: null
      this.asgnLIToFC_tooltip_NAME = asgnLIToFCVal.name ? asgnLIToFCVal.name: null
    }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    showLineItemsErrors () {
      if(!Util.isNullOrEmpty(this.lineItemsErrors) && this.lineItemsErrors.length > 0 ) {
            this.lineItemsErrors.forEach(error => this.$toast.error(error))
        }
    },
    cancelEditMode() {
      this.editMode = false;
      this.getLineItems(this.$route.params.id);
    },
    loaded() {
      this.getFundCitations(this.$route.params.id);
      this.getLineItems(this.$route.params.id);
      this.getLineItemInvoiceStatus(this.$route.params.id);
    },
    async handleEdit() {
      if (this.editMode) {
        await this.saveItemQuantities();
      } else {
        this.editMode = true;
      }
    },
    markChanged(id) {
      if(this.changedItems.includes(id)) return;

      this.changedItems.push(id);
    },
    async updateDisbursment() {

    },
    async saveItemQuantities() {
      let updateStatus = false;
      // Loop through each of the line items
      // Fetch LineItem for each
      let bases = this.lineItems.filter(item => this.changedItems.includes(item.lineItemId));
      let changedLineItemsSet = new Set();

      let items = bases.map(itm => {
        let beforeId = itm.fundCitationId;
      itm.fundCitationId = isNaN(itm.fundCitationName)
        ? beforeId
        : parseInt(itm.fundCitationName);

      let afterId = itm.fundCitationId;
      if(beforeId !== 0 && !changedLineItemsSet.has(beforeId)) {
        changedLineItemsSet.add(beforeId);
      }
      if(afterId !== 0 && !changedLineItemsSet.has(afterId)) {
        changedLineItemsSet.add(afterId);
      }
        return {
          lineItemId: itm.lineItemId,
          orderId: itm.orderId,
          fundCitationId: itm.fundCitationId
        }
      }); 
     
      try {
        const res = await this.saveLineItems(items);
        updateStatus = true;
        await this.getLineItems(this.$route.params.id);
        
        await this.getLineItemInvoiceStatus(this.$route.params.id).then(() => this.showLineItemsErrors());
        
        await this.getFundCitationStatus(this.$route.params.id);
          
        await this.getFundCitations(this.$route.params.id);

        // update disbursment
        let arrChangedItems = Array.from(changedLineItemsSet);
        if(arrChangedItems.length > 0) {
          await this.updateAllDisbursingInfoByOrderId({
            orderId: this.$route.params.id,
            fundcitationIds: arrChangedItems.join(',')
          });
        }
        this.$toast.success(res.data);
      } catch (error) {
        this.$toast.error("ERROR: Cannot save the 'Line Items' at this time.");
      }

      this.editMode = false;
    },
    generateTotal(values) {
      this.getReconciliationStatus(this.$route.params.id);
      if (!values.every((value) => isNaN(value))) {
        this.getReconciliationStatus(this.$route.params.id);
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            this.getReconciliationStatus(this.$route.params.id);
            return prev + curr;
          } else {
            this.getReconciliationStatus(this.$route.params.id);
            return prev;
          }
        }, 0);
      } else {
        this.getReconciliationStatus(this.$route.params.id);
        return null;
      }
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (
            column.property == "requestedQuantity" ||
            column.property == "receivedQuantity"
          ) {
            sums[index] = total ? Util.numberWithCommas(total) : "0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>

<style >
.el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: grey !important;
}
</style>